import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e590aae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asahi-information-container px-5"
}
const _hoisted_2 = { class: "selection-wrapper d-flex align-items-center gap-3 my-3 py-1 px-3" }
const _hoisted_3 = { class: "delivery-date-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "exception-icon"
}
const _hoisted_5 = {
  key: 1,
  class: "cta-create-order"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "cta-create-order"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "asahi-mobile-information-container asahi-order-information-accordion w-100 fw-bold f-14"
}
const _hoisted_10 = {
  class: "accordion w-100",
  id: "asahi-order-information-accordion"
}
const _hoisted_11 = { class: "accordion-item" }
const _hoisted_12 = { class: "accordion-header w-100 d-flex align-items-center" }
const _hoisted_13 = { class: "row align-items-center header-row" }
const _hoisted_14 = {
  key: 0,
  class: "exception-icon col-1"
}
const _hoisted_15 = {
  key: 1,
  class: "col-11"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_17 = { class: "col-1" }
const _hoisted_18 = {
  id: 'asahi-order-information-accordion-collapse-' + 0,
  class: "accordion-collapse collapse w-100"
}
const _hoisted_19 = { class: "accordion-body pt-1" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 align-items-center justify-content-center" }
const _hoisted_22 = { class: "mobile-sold-to mb-2 d-flex justify-content-center" }
const _hoisted_23 = { class: "row align-items-center justify-content-center" }
const _hoisted_24 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_25 = { class: "mobile-sold-to mb-2 d-flex align-items-center" }
const _hoisted_26 = {
  key: 0,
  class: "tooltip-expanded-wrapper"
}
const _hoisted_27 = { class: "d-flex justify-content-center col-12" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiSelectHeader = _resolveComponent("AsahiSelectHeader")!
  const _component_DeliveryDatePicker = _resolveComponent("DeliveryDatePicker")!
  const _component_SolidInfoIcon = _resolveComponent("SolidInfoIcon")!
  const _component_AsahiInfoToolTip = _resolveComponent("AsahiInfoToolTip")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AsahiProgressBar = _resolveComponent("AsahiProgressBar")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!

  return (!_ctx.isMobile && !_ctx.isMoreSection)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AsahiSelectHeader, {
            modelValue: _ctx.selectedShipmentId,
            options: _ctx.shipToOptions,
            "onUpdate:modelValue": _ctx.setShipmentWrapper,
            icon: _ctx.shipToIcon,
            placeholder: _ctx.shipToOptions[0]?.label,
            isTicket: false,
            "is-white": true,
            "no-offset": true,
            isDatePickerOpen: _ctx.isDatePickerOpen,
            arrowColor: 'black',
            "max-height": true
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "isDatePickerOpen"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DeliveryDatePicker, {
              ref: "deliveryDatePickerRef",
              modelValue: _ctx.deliveryDateSelected,
              shipmentId: _ctx.selectedOrderType,
              placeholder: _ctx.$t('Request date'),
              holidayDays: _ctx.holidaysConfig,
              "black-version": true,
              "onUpdate:modelValue": _ctx.onDateSelectionWrapper,
              onOpen: _ctx.handleDatePickerOpen,
              onClose: _ctx.handleDatePickerClose
            }, null, 8, ["modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue", "onOpen", "onClose"])
          ]),
          (_ctx.hasCalendarException)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_AsahiInfoToolTip, null, {
                  content: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_SolidInfoIcon, { fill: "#E17B01" })
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCatalogVisible && _ctx.addToCartLabel && !_ctx.hideCta)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: '/catalog/suggested-cart',
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Create an order', label: _ctx.addToCartLabel, link: '/catalog/products' })), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AsahiButton, {
                      class: "add-to-cart",
                      type: "secondary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.addToCartLabel) + " ", 1),
                        _createElementVNode("img", {
                          src: _ctx.addToCartIcon,
                          alt: "Add to Cart",
                          class: "ms-2"
                        }, null, 8, _hoisted_6)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showSuggestedCart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: '/catalog/suggested-cart',
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateToPath({name: 'Suggested Cart', label: _ctx.$t('Suggested Cart'), link: '/catalog/suggested-cart' })), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AsahiButton, {
                      class: "add-to-cart",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Suggested Cart')) + " ", 1),
                        _createElementVNode("img", {
                          src: _ctx.suggestedCartIcon,
                          alt: "Suggested Cart",
                          class: "ms-2"
                        }, null, 8, _hoisted_8)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["bottle-container", _ctx.messageColorClass?.borderColor])
        }, [
          _createVNode(_component_AsahiProgressBar, {
            percentage: _ctx.cashFilledPercentage,
            error: _ctx.errorWeight,
            success: _ctx.successWeight
          }, null, 8, ["percentage", "error", "success"])
        ], 2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_ctx.hasCalendarException && !_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_AsahiInfoToolTip, null, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_SolidInfoIcon, { fill: "#E17B01" })
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_AsahiTypography, {
                        type: "body-2-regular",
                        color: "text-white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Ship to') + " "), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AsahiTypography, {
                        type: "body-2-regular",
                        class: "text-white me-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currentShippingPlace?.label) + " - " + _toDisplayString(_ctx.formattedDeliveryDate), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AsahiProgressBar, {
                        percentage: _ctx.cashFilledPercentage,
                        error: _ctx.errorWeight,
                        success: _ctx.successWeight,
                        "message-type": "icon-only"
                      }, null, 8, ["percentage", "error", "success"]),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["text-white col-4", {'fw-regular': _ctx.isMobile}])
                    }, _toDisplayString(_ctx.$t('Order details')), 3))
                  : _createCommentVNode("", true),
                (!_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["bottle-container col-6", _ctx.messageColorClass?.borderColor])
                    }, [
                      _createVNode(_component_AsahiProgressBar, {
                        "is-white": true,
                        percentage: _ctx.cashFilledPercentage,
                        error: _ctx.errorWeight,
                        success: _ctx.successWeight,
                        "message-type": "mobile"
                      }, null, 8, ["percentage", "error", "success"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "accordion-button collapsed",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": '#asahi-order-information-accordion-collapse-' + 0,
                    "aria-expanded": "false",
                    "aria-controls": 'asahi-order-information-accordion-collapse-' + 0,
                    onClick: _cache[2] || (_cache[2] = (event) => _ctx.toggleAccordion(event, 0))
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_AsahiSelectHeader, {
                        modelValue: _ctx.selectedShipmentId,
                        options: _ctx.shipToOptions,
                        "onUpdate:modelValue": _ctx.setShipmentWrapper,
                        icon: _ctx.trackIcon,
                        placeholder: _ctx.shipToOptions[0]?.label,
                        "is-white": true,
                        "no-offset": true,
                        "is-mobile": true,
                        "selected-modal": false,
                        title: _ctx.$t('Ship to')
                      }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "title"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.hasCalendarException)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_AsahiInfoToolTip, null, {
                              content: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_SolidInfoIcon, { fill: "#E17B01" })
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_DeliveryDatePicker, {
                          ref: "deliveryDatePickerRef",
                          modelValue: _ctx.deliveryDateSelected,
                          shipmentId: _ctx.selectedOrderType,
                          placeholder: _ctx.$t('Request date'),
                          holidayDays: _ctx.holidaysConfig,
                          "is-mobile": true,
                          transparentBackground: true,
                          "onUpdate:modelValue": _ctx.onDateSelectionWrapper
                        }, null, 8, ["modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_AsahiProgressBar, {
                      "is-white": true,
                      percentage: _ctx.cashFilledPercentage,
                      error: _ctx.errorWeight,
                      success: _ctx.successWeight,
                      "message-type": "mobile-long"
                    }, null, 8, ["percentage", "error", "success"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
}